export const BoxModelMiddle = {
  border: 'solid yellow.15',
  Flex_lineHeight: {
    position: 'absolute',
    alignSelf: 'flex-start',
    borderLeft: '.4)',
    padding: '- - - Y2',
    height: '70%',
    align: 'center center',
    Icon: {
      icon: 'textLineHeight',
      color: '#3A5A7F',
    },
  },
  SizeUnits: {
    LetterValue: null,
    NumberValue: {
      text: '140%',
      color: '#3A5A7F',
      '::after': '%',
      onInput: (ev, el, s) => {
        el.call('updateNumberStateValue', 0, 'lineHeight')
      },
      value: (el, s) => el.call('getNumberValueFromState', 0, 'lineHeight'),
    },
  },
  flow: 'column',
  align: 'center center',
  position: 'relative',
  height: 'C1',
  borderWidth: '.8px',
  padding: '- - - Y',
  round: 'Y2',
  minWidth: 'E3',
};